import React, { Children } from "react";
import { Modal, Box, Typography, Divider , Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "./CustomButton";
import PrimaryButton from "./PrimaryButton";



const DataModal = ({
  open,
  onClose,
  processing,
  discardChanges,
  saveChanges,
  ButtonTitle,
  HeadrTitle,
  children, 
  disabled,
  changeWidth
}) => {


  const Modalstyle = {
    position: "absolute",
    top: changeWidth ? "42%" : "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: changeWidth ? changeWidth : 544,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: '5px',
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-un-saved-changes"
      aria-describedby="modal-un-saved-changes"
    >
      <Box sx={Modalstyle}>
        <Box
          sx={{
            bgcolor: "#050D2E",
            padding: "20px",
            color: "#ffffff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderTopLeftRadius: '5px',
            borderTopRightRadius: '5px'
          }}
        >
          <Typography
            id="change-license"
            sx={{
              fontSize: "1.25rem",
              fontWeight: 550,
              lineHeight: "24px",
            }}
          >
           {HeadrTitle}
          </Typography>
          <CloseIcon sx={{ cursor: "pointer" }} onClick={discardChanges} />
        </Box>

          <Box
          sx={{
            padding:'45px',
           
          }}
          >

{children}
          </Box>

        <Divider />

        <Grid
            container
            justifyContent="flex-end"
            columnSpacing={2}
            sx={{ 
             
              padding: "20px 30px 20px 20px",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
          
            }}
        >
          <PrimaryButton onClick={discardChanges}>Cancel</PrimaryButton>
          
          <div style={{ width: "10px" }}></div>
          <CustomButton
            text={ButtonTitle}
            type="update"
            processing={processing}
            action={saveChanges}
            disabled={disabled}
          />
        </Grid>
      </Box>
    </Modal>
  );
};

export default DataModal;
